import { useTranslation } from 'react-i18next';
import VideoPlayer from '@/components/VideoPlayer';
import iphoneBezel from '@/assets/bezel.png';
import useVideoControl from '@/hooks/useVideoControl';

const FinishPage = () => {
  const { t } = useTranslation('applyJob');
  const { setCurRef, play } = useVideoControl();
  const { i18n } = useTranslation();
  const finalVideoSrc =
    i18n.language === 'spanish' ? '/final_video_es.mp4' : '/final_video_en.mp4';

  return (
    <div className="min-h-screen flex flex-col justify-self-center items-center w-full bg-[url(/lang_bg.png)]">
      <div className="min-h-screen flex flex-col items-center justify-between gap-4 py-16 px-6 max-w-md w-full text-center">
        <h1 className="text-[#1E3A8A] text-xl font-bold">
          {t('finish.title')}
        </h1>
        <p className="text-base font-bold">{t('finish.message.line1')}</p>
        <p className="text-base font-bold">{t('finish.message.line2')}</p>

        <div className="w-[270px] h-[465px] p-2.5 relative">
          <img
            src={iphoneBezel}
            alt=""
            className="absolute w-full h-full top-0 left-0 z-10"
            onClick={play}
          />
          <VideoPlayer
            width="250px"
            height="445px"
            style={{ borderRadius: '36px' }}
            src={finalVideoSrc}
            onSetCurRef={setCurRef}
            autoPlay
          />
        </div>

        <p className="text-[#1E3A8A] text-xl font-bold">{t('finish.seeYou')}</p>
      </div>
    </div>
  );
};

export default FinishPage;
